import React from 'react';
import {
    IconButton,
    TableContainer,
    Table,
    TableHead,
    TableCell,
    TableRow,
    TableBody,
} from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import * as icons from 'mdi-material-ui';

const useStyles = makeStyles(theme => ({
    table: { marginBottom: 32 },
    tableBody: { height: '100%' },
    headerCell: {
        fontSize: 16,
        border: '1px solid #ccc',
        textAlign: 'center',
    },
}));

export const CommonTable = ({ tableHeaders, children, addRow }) => {
    const classes = useStyles();

    return (
        <TableContainer className={classes.table}>
            <Table aria-label="caption table">
                <TableHead>
                    <TableRow>
                        {tableHeaders.map(th => (
                            <TableCell key={th} classes={{ root: classes.headerCell }}>
                                {th}
                            </TableCell>
                        ))}
                        <td>
                            <IconButton color="primary" size="small" onClick={addRow}>
                                <icons.PlusCircle />
                            </IconButton>
                        </td>
                    </TableRow>
                </TableHead>
                <TableBody className={classes.tableBody}>{children}</TableBody>
            </Table>
        </TableContainer>
    );
};
